module.exports = __webpack_public_path__ + "images/emoji/sleeping.95eaa23ed45b7ce8e307.png";